export const BuilderComponentDeadCompTranslationKeys = {
	NAMESPACE: 'Platform',
	BUILDER_LOADING_ERROR_HEADER_DEFAULT: 'Not Authorized',
	BUILDER_LOADING_ERROR_TEXT1_DEFAULT: 'You are not authorized to see this component.',
} as const
